var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { Entity } from '@square/dashboard-protos/models/squareup/sub2/data';
import { assert } from '@ember/debug';
import Sub2Client from '@square/dashboard-data/clients/sub2';
export let GroupToken = /*#__PURE__*/function (GroupToken) {
  GroupToken["STAFF_GROUP"] = "staff-group-v2";
  GroupToken["STAFF_GROUP_PER_LOCATION"] = "staff-group-v2-per-location";
  return GroupToken;
}({});
export let PlanToken = /*#__PURE__*/function (PlanToken) {
  PlanToken["STAFF_FREE"] = "staff-free";
  PlanToken["STAFF_FREE_PER_LOCATION"] = "staff-free-per-location";
  PlanToken["STAFF_PLUS"] = "staff-plus-v2";
  PlanToken["STAFF_PLUS_PER_LOCATION"] = "staff-plus-v2-per-location";
  PlanToken["STAFF_PREMIUM"] = "staff-premium-v2";
  PlanToken["STAFF_PREMIUM_PER_LOCATION"] = "staff-premium-v2-per-location";
  PlanToken["STAFF_ALLINONE"] = "staff-allinone";
  PlanToken["STAFF_ALLINONE_PER_LOCATION"] = "staff-allinone-per-location";
  PlanToken["PAYROLL_FOR_CONTRACTORS"] = "payroll_for_contractors";
  PlanToken["PAYROLL_FOR_EMPLOYEES"] = "payroll_for_employees";
  PlanToken["ADVANCED_ACCESS_PER_LOCATION"] = "advanced-access-per-location";
  PlanToken["HR_MANAGER"] = "hr-manager-monthly";
  return PlanToken;
}({});
let StaffSubscriptions = (_class = class StaffSubscriptions extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "modal", _descriptor2, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor3, this);
    _initializerDefineProperty(this, "i18n", _descriptor4, this);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor5, this);
    _initializerDefineProperty(this, "staffPackagesPricingInfo", _descriptor6, this);
    _defineProperty(this, "subscriptions", {});
    _defineProperty(this, "currentSubscriptionPlan", void 0);
  }
  async getActivateComponent(planToken) {
    let mod;
    switch (planToken) {
      case PlanToken.STAFF_FREE:
      case PlanToken.STAFF_FREE_PER_LOCATION:
        mod = await import('@dashboard/subscriptions/components/subscriptions/merchant/verticals/activate/staff-free-activate-product-details-row');
        return mod.default;
      case PlanToken.STAFF_PLUS:
      case PlanToken.STAFF_PLUS_PER_LOCATION:
        mod = await import('@dashboard/subscriptions/components/subscriptions/merchant/verticals/activate/staff-plus-activate-product-details-row');
        return mod.default;
      case PlanToken.STAFF_PREMIUM:
      case PlanToken.STAFF_PREMIUM_PER_LOCATION:
        mod = await import('@dashboard/subscriptions/components/subscriptions/merchant/verticals/activate/staff-premium-activate-product-details-row');
        return mod.default;
      case PlanToken.STAFF_ALLINONE:
      case PlanToken.STAFF_ALLINONE_PER_LOCATION:
        mod = await import('@dashboard/subscriptions/components/subscriptions/merchant/verticals/activate/staff-allinone-activate-product-details-row');
        return mod.default;
      case PlanToken.ADVANCED_ACCESS_PER_LOCATION:
        mod = await import('@dashboard/subscriptions/components/subscriptions/merchant/verticals/activate/advanced-access-activate-product-details-row');
        return mod.default;
      case PlanToken.PAYROLL_FOR_CONTRACTORS:
      case PlanToken.PAYROLL_FOR_EMPLOYEES:
        mod = await import('@dashboard/subscriptions/components/subscriptions/merchant/verticals/activate/payroll-for-employees-activate-product-details-row');
        return mod.default;
      default:
        return undefined;
    }
  }
  getPlanName(planToken) {
    switch (planToken) {
      case PlanToken.STAFF_FREE:
      case PlanToken.STAFF_FREE_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.free');
      case PlanToken.STAFF_PLUS:
      case PlanToken.STAFF_PLUS_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.plus');
      case PlanToken.STAFF_PREMIUM:
      case PlanToken.STAFF_PREMIUM_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.premium');
      case PlanToken.STAFF_ALLINONE:
      case PlanToken.STAFF_ALLINONE_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.allinone');
      case PlanToken.PAYROLL_FOR_CONTRACTORS:
      case PlanToken.PAYROLL_FOR_EMPLOYEES:
        return this.i18n.t('employees.staff.packages.toasts.staff.payroll');
      case PlanToken.ADVANCED_ACCESS_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.advanced.access');
      case PlanToken.HR_MANAGER:
        return this.i18n.t('employees.staff.packages.toasts.staff.hr.manager');
      default:
        return assert('default case should never reach');
    }
  }
  async loadPricingInfo(planToken) {
    if (this.staffPackagesPricingInfo[planToken] === undefined) {
      const planInfo = await Sub2Client.externalGetPricingInfo({
        planToken
      });

      // trigger update
      this.staffPackagesPricingInfo = {
        ...this.staffPackagesPricingInfo,
        [planToken]: planInfo
      };
    }
  }
  async loadSubscriptions() {
    const loadingSubscriptions = Object.values(PlanToken).map(value => this.tryGetSubscription(value).then(subscription => {
      this.subscriptions[value] = subscription;
      if (this.subscriptions[value]?.planGroupToken === GroupToken.STAFF_GROUP || this.subscriptions[value]?.planGroupToken === GroupToken.STAFF_GROUP_PER_LOCATION) {
        this.currentSubscriptionPlan = this.subscriptions[value];
      }
    }));
    await Promise.all(loadingSubscriptions);
  }
  async tryGetSubscription(planToken) {
    const subscriber = Entity.create({
      tokenType: Entity.TokenType.MERCHANT,
      token: this.userInfo.merchantToken
    });
    try {
      const {
        subscription
      } = await Sub2Client.externalGetSubscription({
        subscriptionKey: {
          subscriber,
          planToken
        }
      });
      return subscription;
    } catch (e) {
      // This endpoint returns a 404 response if the merchant does not have this type of subscription
      if (e.responseStatus === 404) {
        return undefined;
      } else {
        throw e;
      }
    }
  }
  async openSingleCheckoutModal({
    planToken,
    locationPlanToken
  }) {
    if (!this.currentSubscriptionPlan) {
      await this.loadSubscriptions();
    }
    const token = this.currentSubscriptionPlan?.planGroupToken === GroupToken.STAFF_GROUP ? planToken : locationPlanToken;
    const successMessage = this.i18n.t('employees.staff.packages.toasts.success', {
      planName: this.getPlanName(token)
    });

    /* eslint-disable dashboard/require-modal-open-component, @typescript-eslint/ban-ts-comment */
    // @ts-ignore legacy string-based modal open
    const result = await this.modal.open('subscriptions/sub2-activation-modal', {
      planToken: token,
      subscriptionToken: this.currentSubscriptionPlan?.token
    });
    /* eslint-enable dashboard/require-modal-open-component, @typescript-eslint/ban-ts-comment */
    const {
      didSubscribe,
      features
    } = result;
    if (didSubscribe) {
      const featureStatuses = features?.featureStatuses;

      // update subscribed features to correctly reflect subscriptions status
      if (featureStatuses) {
        await this.userSubscriptions.updateSubscriptionFeatures(featureStatuses);
      }
      this.marketToasts.success(successMessage);
    }
    return {
      didSubscribe: Boolean(didSubscribe)
    };
  }
  async openMultiCheckoutModal({
    planToken,
    locationPlanToken
  }) {
    if (!this.currentSubscriptionPlan) {
      await this.loadSubscriptions();
    }
    const token = this.currentSubscriptionPlan?.planGroupToken === GroupToken.STAFF_GROUP ? planToken : locationPlanToken;
    await this.loadPricingInfo(token);
    const pricingInfo = this.staffPackagesPricingInfo[token];
    if (!pricingInfo) {
      return {
        didSubscribe: false
      };
    }
    const productInfos = [{
      productName: this.getPlanName(token),
      productHeaderText: '',
      productHeaderSubtext: this.i18n.t('employees.staff.packages.perMonth'),
      planInfos: [{
        planName: this.getPlanName(token),
        planToken: token,
        planBillingCycleCadence: 'monthly',
        component: await this.getActivateComponent(token),
        pricingInfo
      }]
    }];

    /* eslint-disable dashboard/require-modal-open-component, @typescript-eslint/ban-ts-comment */
    // prettier-ignore
    // @ts-ignore legacy string-based modal open
    const multiResult = await this.modal.open('subscriptions/merchant/activate-subscription/multi-product-activate-modal', {
      productInfos,
      modalConfig: {
        keepModalOpenOnFailure: true
      }
    });
    /* eslint-enable dashboard/require-modal-open-component, @typescript-eslint/ban-ts-comment */
    const {
      didSubscribe
    } = multiResult;
    return {
      didSubscribe: Boolean(didSubscribe)
    };
  }
  async openBundleCheckoutModal() {
    /* eslint-disable dashboard/require-modal-open-component, @typescript-eslint/ban-ts-comment */
    // @ts-ignore legacy string-based modal open
    const bundleResult = await this.modal.open('subscriptions/merchant/bundling/bundle-checkout-modal', {});
    /* eslint-enable dashboard/require-modal-open-component, @typescript-eslint/ban-ts-comment */
    const {
      didSubscribe
    } = bundleResult;
    return {
      didSubscribe: Boolean(didSubscribe)
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "staffPackagesPricingInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _class);
export { StaffSubscriptions as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.